import { HttpClient } from '@angular/common/http';
import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-taxe-nedebitate-achitate',
    templateUrl: './taxe-nedebitate-achitate.component.html',
    styleUrls: ['./taxe-nedebitate-achitate.component.scss'],
})
export class TaxeNedebitateAchitateComponent
    implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;
    cnp_cui: string = '';
    persoana_id: string = '';
    isLoading = false;
    showCard = false;
    selectedSection: string = '';

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();

    dtLink =
        environment.interop.basePath +
        environment.interop.payments.nomenclatoare.taxeNedebitatePayments
            .getTaxeNedebitatePayments;

    dataTablesParameters: any = {
        data: {
            key: 'parameter',
        },
    };

    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            responsive: true,
            searching: false,
            pageLength: 25,

            ajax: (dataTablesParameters: any, callback: any) => {
                dataTablesParameters.date_from = '2020-05-01';
                dataTablesParameters.date_to = new Date().toISOString().slice(0, 10);
                dataTablesParameters.cnp_cui = this.cnp_cui;
                dataTablesParameters.persoana_id = this.persoana_id;
                this.isLoading = true;
                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: '#',
                    data: 'id',
                },
                {
                    title: 'CNP/CUI',
                    data: 'cnp_cui',
                },
                {
                    title: 'Cetățean/Companie',
                    data: 'denumire_cet_comp',
                },
                {
                    title: 'Rol ID',
                    data: 'persoana_id',
                },
                {
                    title: 'Suma Încasată',
                    data: null,
                    render: (data: any) => {
                        return `
                            <div> ${data.suma_de_achitat} RON</div>
                        `;
                    },
                },
                {
                    title: 'Info Plată',
                    data: null,
                    render: (data: any) => {
                        return `
               <div>${data.id_payment}/${data.payment_date}</div>
               <div>${data.contIBAN}</div>
              `;
                    },
                },
                {
                    title: 'Înregistrată',
                    data: 'created_at',
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit');

                if (editIcon) {
                    editIcon.addEventListener('click', () => { });
                }

                return row;
            },
        };
    }
    toggleCard() {
        this.showCard = !this.showCard;
    }
    applyFilters(): void {
        this.rerenderDT(true);
    }
    resetForm() {
        this.cnp_cui = '';
        this.persoana_id = '';

        this.rerenderDT();
        this.showCard = true;
    }

    rerenderDT(resetPaging = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(resetPaging);
        });
        this.showCard = false;
    }
}
